export default "/storefront/client/images/chrome.png";